(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["burn-extreme-bday-benefits"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '.bday-benefits';
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function reveal(section) {
    section.classList.add('bday-benefits--reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bday-benefits--in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    observer.observe(section);
  }

  function init() {
    if (!('IntersectionObserver' in window) || !motionOk.matches) return;
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      reveal(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-compare"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '.bday-compare';
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function reveal(section) {
    section.classList.add('bday-compare--reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bday-compare--in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    observer.observe(section);
  }

  function init() {
    if (!('IntersectionObserver' in window) || !motionOk.matches) return;
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      reveal(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-facts"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function whenSplide(callback) {
    if (window.Splide) { callback(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Splide || tries++ > 50) {
        clearInterval(timer);
        if (window.Splide) callback();
      }
    }, 100);
  }

  function initSection(section) {
    var el = section.querySelector('.bday-facts__slider');
    if (!el) return;
    var multiple = el.querySelectorAll('.splide__slide').length > 1;
    new Splide(el, {
      type: 'slide',
      perPage: 1,
      arrows: false,
      pagination: false,
      drag: multiple
    }).mount();
  }

  function init() {
    document.querySelectorAll('.bday-facts').forEach(function (section) {
      whenSplide(function () { initSection(section); });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-flavors"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '.bday-flavors';
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function reveal(section) {
    section.classList.add('bday-flavors--reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bday-flavors--in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2 });

    observer.observe(section);
  }

  function init() {
    if (!('IntersectionObserver' in window) || !motionOk.matches) return;
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      reveal(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-stages"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '.bday-stages';
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function reveal(section) {
    section.classList.add('bday-stages--reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bday-stages--in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    observer.observe(section);
  }

  function init() {
    if (!('IntersectionObserver' in window) || !motionOk.matches) return;
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      reveal(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function whenSplide(callback) {
    if (window.Splide) { callback(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Splide || tries++ > 50) {
        clearInterval(timer);
        if (window.Splide) callback();
      }
    }, 100);
  }

  function init() {
    document.querySelectorAll('.bday-trust__photos').forEach(function (el) {
      whenSplide(function () {
        new Splide(el, {
          type: 'loop',
          autoWidth: true,
          gap: '1rem',
          arrows: true,
          pagination: true,
          drag: 'free',
          focus: 0,
          omitEnd: true,
          breakpoints: {
            990: { padding: { left: '0.9375rem', right: '0' } }
          }
        }).mount();
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function whenSplide(callback) {
    if (window.Splide) { callback(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Splide || tries++ > 50) {
        clearInterval(timer);
        if (window.Splide) callback();
      }
    }, 100);
  }

  function setupCards(section) {
    var cards = section.querySelectorAll('.bday-videos__card');
    cards.forEach(function (card) {
      var video = card.querySelector('.bday-videos__video');
      var play = card.querySelector('.bday-videos__play');
      if (!video) return;

      function toggle() {
        if (video.paused) { video.play(); } else { video.pause(); }
      }

      if (play) play.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
      video.addEventListener('play', function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }

  function pauseAll(section) {
    section.querySelectorAll('.bday-videos__video').forEach(function (video) {
      if (!video.paused) video.pause();
    });
  }

  function initSection(section) {
    var el = section.querySelector('.bday-videos__carousel');
    if (!el) { setupCards(section); return; }

    var splide = new Splide(el, {
      type: 'slide',
      perPage: 4,
      gap: '1rem',
      arrows: true,
      pagination: true,
      rewind: true,
      breakpoints: {
        990: { perPage: 1, gap: '1rem', padding: { left: '0.9375rem', right: '3.5rem' } }
      }
    });

    // Pause every video before navigating so audio never overlaps.
    splide.on('move', function () { pauseAll(section); });
    splide.mount();
    setupCards(section);
  }

  function init() {
    document.querySelectorAll('.bday-videos').forEach(function (section) {
      whenSplide(function () { initSection(section); });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
